import { motion } from "framer-motion";
import { ArrowUpRight, LifeBuoy } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const SUPPORT_EMAIL = "teamup.dev.app@gmail.com";

export const SupportSection = () => {
  const { t } = useLanguage();

  return (
    <section id="support" data-testid="teamup-support-contact-section" className="border-t border-white/[0.07]">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-24 sm:px-8 md:grid-cols-2 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="mb-5 flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.3em] text-brand sm:text-xs">
            <LifeBuoy className="h-4 w-4" />
            {t.support.eyebrow}
          </p>
          <h2 className="font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-5xl">
            {t.support.heading}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col justify-center"
        >
          <p className="max-w-md text-base leading-relaxed text-mist sm:text-lg">{t.support.text}</p>
          <a
            data-testid="teamup-contact-mailto-button"
            href={`mailto:${SUPPORT_EMAIL}`}
            className="group mt-8 flex w-fit items-center gap-2.5 rounded-full border border-brand/50 px-7 py-3.5 font-semibold text-brand transition-all duration-300 hover:bg-brand hover:text-white"
          >
            {t.support.contact}
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
